import React, { useEffect, useState } from 'react';
import './Layout3.css';
import { ForwardIcon, HeartIcon, MessageCircleMore } from 'lucide-react';
import InstagramEmbed from '../../InstagramEmbed';

const Layout3 = ({ data }) => {
  const { video, brand, copy, cta, canvas } = data;
  const [frameBG, setFrameBG] = useState('');
  const [frameBorder, setFrameBorder] = useState('');

  useEffect(() => {
    const applyLutDarkness = (hex, darkness = 1) => {
      hex = hex.replace("#", "");

      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      r = Math.floor((r / 255) * 255 * darkness);
      g = Math.floor((g / 255) * 255 * darkness);
      b = Math.floor((b / 255) * 255 * darkness);

      return `rgb(${Math.min(255, r)}, ${Math.min(255, g)}, ${Math.min(255, b)})`;
    };
    const bgColor = applyLutDarkness(canvas.gradientColor2, 0.6);
    setFrameBG(bgColor);

    const borderColor = applyLutDarkness(canvas.gradientColor2, 1.2);
    setFrameBorder(borderColor);

  }, [canvas?.gradientColor2]);



  return (
    <div className="layout3-root">
      <div className="layout3-vignette" />

      <div className="layout3-main">
        {/* Left: Phone / video */}
        <div className="layout3-phoneWrap">
          <div className="layout3-phoneFrame" style={{
            backgroundColor: frameBG,
            border: `2px solid ${frameBorder}`
          }}>
            <div className="layout3-phoneInner">
              {video?.url && video.url ? (
                video.url.includes("instagram.com") ? (
                  <InstagramEmbed key={video.url} postUrl={video.url} />
                ) : (
                  <>
                    <video className="layout3-video" src={video.url} autoPlay muted loop playsInline />

                    <div className="absolute bottom-0 left-0 w-full py-4 px-7 flex items-center justify-between gap-10 text-white">
                      <span><HeartIcon fill="red" stroke="red" className="h-6 w-6" /></span>
                      <span><MessageCircleMore className="h-6 w-6" /></span>
                      <span><ForwardIcon className="h-6 w-6" /></span>
                    </div>
                  </>
                )
              ) : (
                <div className="layout3-videoPlaceholder">
                  <div className="layout3-play">▶</div>
                  <div>Upload Video</div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right: Content */}
        <div className="layout3-content">
          <div className="layout3-brandRow">
            <div className="layout3-brandLogo">
              {brand?.logoUrl ? (
                <img className="layout3-brandLogoImg" src={brand.logoUrl} alt="Brand logo" />
              ) : (
                <div className="layout3-brandLogoFallback">
                  {brand?.name
                    ? brand.name
                      .split(" ")
                      .map(word => word[0])
                      .join("")
                      .toUpperCase()
                      .slice(0, 2)
                    : "RL"
                  }
                </div>
              )}
            </div>
            <div className="layout3-brandMeta">
              <div className="layout3-brandName">
                {brand?.name || 'Ralph Lauren'}
                {brand?.verified ? <span className="layout3-verified">✓</span> : null}
              </div>
              <div className="layout3-followers">{brand?.followers || '331K Followers'}</div>
            </div>
          </div>

          <div className="layout3-title">
            {copy?.title || "Polo Ralph Lauren: Men's Outerwear"}
          </div>
          <div className="layout3-desc">
            {copy?.description ||
              'Rugged yet refined, #PoloRalphLauren leather and suede jackets are thoughtfully designed for durability and a timeless sartorial appeal.'}
          </div>

          <div className="layout3-bottomRow">
            <div className="layout3-qrBox">
              {brand?.qrCodeUrl ? (
                <img className="layout3-qrImg" src={brand.qrCodeUrl} alt="QR" />
              ) : (
                <div className="layout3-qrPlaceholder">QR</div>
              )}
            </div>
            <div className="layout3-cta">
              <div className="layout3-ctaText">{cta?.text || 'Shop Now'}</div>
              <div className="layout3-ctaSub">{cta?.website || 'ralphlauren.com'}</div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Layout3;

